import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
//import Select from '@material-ui/core/Select';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    topLabel: {
        margin: 0,
        padding: 0
    }
}));

export default function DropDown(props) {
    const classes = useStyles();
    return (
        <form className={classes.root} autoComplete="off">
            <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-native-label-placeholder">{props.labelText || ''}</InputLabel>
                <NativeSelect
                    error={props.error}
                    value={props.value}
                    onChange={props.onChange(props.name)}
                    inputProps={{
                        name: props.name,
                        id: 'age-native-label-placeholder',
                    }}
                >
                     {props.children}
                </NativeSelect>
                <FormHelperText>{props.helperText || ''}</FormHelperText>
            </FormControl>

        </form>
    );
}